// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"529":"a8050359","771":"cfe00102","795":"a8050359","900":"f8f21753"}[chunkId] + ".chunk.css";
};